export default "__VITE_ASSET__Dquq$hle__"